@if (item.customField33 == '2' ) {
  <div>
    @if (item.customField15 == '1' ) {
      <div fxLayout="row" class="table-align">
        <div fxLayout="column" fxFlex="25" class="cell">
        </div>
        <div fxLayout="column" fxFlex="25" class="cell">
          <mat-icon class="maticon1">check_circle</mat-icon>
          <h4><b>Starter</b></h4>
          <button mat-stroked-button  class="trybtn1">TRY NOW</button>
        </div>
        <div fxLayout="column" fxFlex="25" class="cell">
          <mat-icon class="maticon2">check_circle</mat-icon>
          <h4><b>Professional</b></h4>
          <button mat-stroked-button  class="trybtn2">TRY NOW</button>
        </div>
        <div fxLayout="column" fxFlex="25" class="cell">
          <mat-icon class="maticon_3">check_circle</mat-icon>
          <h4><b>Advanced</b></h4>
          <button mat-stroked-button  class="trybtn3">TRY NOW</button>
        </div>
      </div>
    }
    @if (item.customField15 == '2' ) {
      <div fxLayout="row" class="table-align" [style.background-color]="item.customField20"
        [style.color]="item.customField21">
        <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
          <h4><b>{{item.customField16}}</b></h4>
        </div>
        <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
          <h4><b>{{item.customField17}}</b></h4>
        </div>
        <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
          <h4><b>{{item.customField18}}</b></h4>
        </div>
        @if (item.customField19.length>0) {
          <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
            <h4><b>{{item.customField19}}</b></h4>
          </div>
        }
      </div>
    }
    @for (data of pricedetail; track data) {
      <div>
        @if (data.title) {
          <div fxLayout="row" class="subTitle">
            <p><b>{{data.title}}</b></p>
          </div>
        }
        @for (item of data.list_detail; track item) {
          <div>
            <div fxLayout="row" class="rowtype">
              <div [fxFlex]="item.advanced==''?33.33:25" class="celltype">
                <p>{{item.sub_title}}</p>
              </div>
              <div [fxFlex]="item.advanced==''?33.33:25" class="celltype">
                @if (item.starter !== 'yes' && item.starter !== 'no') {
                  <p style="text-align: center;">
                  {{item.starter}}</p>
                }
                @if (item.starter === 'yes' ) {
                  <mat-icon class="maticon3">check_circle</mat-icon>
                }
                @if (item.starter === 'no' ) {
                  <mat-icon class="maticon4">cancel</mat-icon>
                }
              </div>
              <div [fxFlex]="item.advanced==''?33.33:25" class="celltype">
                @if (item.profession !== 'yes' && item.profession !== 'no') {
                  <p style="text-align: center;">
                  {{item.profession}}</p>
                }
                @if (item.profession === 'yes' ) {
                  <mat-icon class="maticon3">check_circle</mat-icon>
                }
                @if (item.profession === 'no' ) {
                  <mat-icon class="maticon4">cancel</mat-icon>
                }
              </div>
              @if (item.advanced.length>0) {
                <div fxFlex="25%" class="celltype">
                  @if (item.advanced !== 'yes' && item.advanced !== 'no') {
                    <p style="text-align: center;">
                    {{item.advanced}}</p>
                  }
                  @if (item.advanced === 'yes' ) {
                    <mat-icon class="maticon3">check_circle</mat-icon>
                  }
                  @if (item.advanced === 'no' ) {
                    <mat-icon class="maticon4">cancel</mat-icon>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}

@if (item.customField33 == '4' ) {
  <div>
    <div fxHide.lt-md>
      <div fxLayout="row" class="table-align" [style.background-color]="item.customField20"
        [style.color]="item.customField21">
        <div fxLayout="column" fxFlex="25" class="cell">
          <h4><b>{{item.customField16}}</b></h4>
        </div>
        <div fxLayout="column" fxFlex="25" class="cell">
          <h4><b>{{item.customField17}}</b></h4>
        </div>
        <div fxLayout="column" fxFlex="25" class="cell" [style.background-color]="item.customField23">
          <h4 style="color: white;"><b>{{item.customField18}}</b></h4>
        </div>
        <div fxLayout="column" fxFlex="25" class="cell">
          <h4><b>{{item.customField19}}</b></h4>
        </div>
      </div>
      <div id="catList">
        @for (items of price_detail; track items; let i = $index) {
          <mat-list
            [ngClass]="{'accordion-list':items.list_detail.length ==0,'':items.list_detail.length >0}" lines="none"
            class="child-list" detail="false" no-padding menuClose style="border-bottom: 1px solid lightgray;">
            <div matRipple tappable [style.background-color]="item.customField20"
              [ngClass]="{'section-active': items.open, 'section': !items.open}">
              @if (items.title) {
<div fxLayout="row" fxLayoutAlign="space-between center" style="border-bottom: 1px solid lightgray;border-left: 1px solid lightgray;
                    border-right: 1px solid lightgray;"
                  >
                  <mat-label fxFlex="80" style="padding-left: 10px;font-size: 16px;" color="dark"
                    [style.color]="item.customField23" class="itemLabel padding-10" (click)="toggleSection(i)">
                    {{ items.title }}
                  </mat-label>
                  @if (items.list_detail.length >0 && items.open !=true) {
                    <mat-icon (click)="toggleSection(i)" matSuffix class="toggleicon"
                      [style.color]="item.customField23"
                    >keyboard_arrow_down</mat-icon>
                  }
                  @if (items.open ==true) {
                    <mat-icon (click)="toggleSection(i)" class="toggleicon" [style.color]="item.customField23"
                    >keyboard_arrow_up</mat-icon>
                  }
                </div>
              }
            </div>
            @if (items.list_detail && items.open) {
              <div menuClose>
                @for (items of items.list_detail; track items) {
                  <div>
                    <div fxLayout="row"
                      style="border-bottom: 1px solid lightgray;border-left: 1px solid lightgray;">
                      <div fxFlex="25%" class="celltype" fxLayoutAlign="start start">
                        <p style="font-size: 16px;padding-top: 20px;padding-bottom: 20px;">{{items.sub_title}}</p>
                      </div>
                      <div fxFlex="25%" class="celltype">
                        @if (items.starter !== 'yes' && items.starter !== 'no') {
                          <p style="text-align: center;font-size: 16px;padding-top: 20px;padding-bottom: 20px;"
                            >
                          {{items.starter}}</p>
                        }
                        @if (items.starter === 'yes' ) {
                          <mat-icon class="maticon5">done</mat-icon>
                        }
                        @if (items.starter === 'no' ) {
                          <mat-icon class="maticon6">close</mat-icon>
                        }
                      </div>
                      <div fxFlex="25%" class="celltype" [style.background-color]="item.customField20">
                        @if (items.profession !== 'yes' && items.profession !== 'no') {
                          <p style="text-align: center;font-size: 16px;padding-top: 20px;padding-bottom: 20px;" [style.color]="item.customField23"
                            >
                          {{items.profession}}</p>
                        }
                        @if (items.profession === 'yes' ) {
                          <mat-icon class="maticon5" [style.color]="item.customField23"
                          >done</mat-icon>
                        }
                        @if (items.profession === 'no' ) {
                          <mat-icon class="maticon6" [style.color]="item.customField23"
                          >close</mat-icon>
                        }
                      </div>
                      <div fxFlex="25%" class="celltype">
                        @if (items.advanced !== 'yes' && items.advanced !== 'no') {
                          <p style="text-align: center;font-size: 16px;padding-top: 20px;padding-bottom: 20px;"
                            >
                          {{items.advanced}}</p>
                        }
                        @if (items.advanced === 'yes' ) {
                          <mat-icon class="maticon5">done</mat-icon>
                        }
                        @if (items.advanced === 'no' ) {
                          <mat-icon class="maticon6">close</mat-icon>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </mat-list>
        }
      </div>
    </div>
    <div fxHide fxShow.lt-md>
      <div fxLayout="row" class="table-align" [style.background-color]="item.customField20"
        [style.color]="item.customField21">
        <div fxLayout="column" fxFlex="40" class="cell">
          <h4><b>{{item.customField16}}</b></h4>
        </div>
        <div fxLayout="column" fxFlex="20" class="cell">
          <h4><b>{{item.customField17}}</b></h4>
        </div>
        <div fxLayout="column" fxFlex="20" class="cell" [style.background-color]="item.customField23">
          <h4 style="color: white;"><b>{{item.customField18}}</b></h4>
        </div>
        <div fxLayout="column" fxFlex="20" class="cell">
          <h4><b>{{item.customField19}}</b></h4>
        </div>
      </div>
      <div id="catList">
        @for (items of price_detail; track items; let i = $index) {
          <mat-list
            [ngClass]="{'accordion-list':items.list_detail.length ==0,'':items.list_detail.length >0}" lines="none"
            class="child-list" detail="false" no-padding menuClose style="border-bottom: 1px solid lightgray;">
            <div matRipple tappable [style.background-color]="item.customField20"
              [ngClass]="{'section-active': items.open, 'section': !items.open}">
              @if (items.title) {
                <div fxLayout="row" fxLayoutAlign="space-between center" style="border-bottom: 1px solid lightgray;"
                  >
                  <mat-label fxFlex="80" style="padding-left: 10px;font-size: 11px;" color="dark"
                    [style.color]="item.customField23" class="itemLabel padding-10" (click)="toggleSection(i)">
                    {{ items.title }}
                  </mat-label>
                  @if (items.list_detail.length >0 && items.open !=true) {
                    <mat-icon (click)="toggleSection(i)" matSuffix class="toggleicon"
                      [style.color]="item.customField23"
                    >keyboard_arrow_down</mat-icon>
                  }
                  @if (items.open ==true) {
                    <mat-icon (click)="toggleSection(i)" class="toggleicon" [style.color]="item.customField23"
                    >keyboard_arrow_up</mat-icon>
                  }
                </div>
              }
            </div>
            @if (items.list_detail && items.open) {
              <div menuClose>
                @for (items of items.list_detail; track items) {
                  <div>
                    <div fxLayout="row"
                      style="border-bottom: 1px solid lightgray;border-left: 1px solid lightgray;">
                      <div fxFlex="40%" class="celltype" fxLayoutAlign="start start">
                        <p style="font-size: 11px;">{{items.sub_title}}</p>
                      </div>
                      <div fxFlex="20%" class="celltype" fxLayoutAlign="center center">
                        @if (items.starter !== 'yes' && items.starter !== 'no') {
                          <p style="text-align: center;font-size: 11px;"
                            >
                          {{items.starter}}</p>
                        }
                        @if (items.starter === 'yes' ) {
                          <mat-icon class="maticon5">done</mat-icon>
                        }
                        @if (items.starter === 'no' ) {
                          <mat-icon class="maticon6">close</mat-icon>
                        }
                      </div>
                      <div fxFlex="20%" class="celltype" [style.background-color]="item.customField20" fxLayoutAlign="center center">
                        @if (items.profession !== 'yes' && items.profession !== 'no') {
                          <p style="text-align: center;font-size: 11px;" [style.color]="item.customField23"
                            >
                          {{items.profession}}</p>
                        }
                        @if (items.profession === 'yes' ) {
                          <mat-icon class="maticon5" [style.color]="item.customField23"
                          >done</mat-icon>
                        }
                        @if (items.profession === 'no' ) {
                          <mat-icon class="maticon6" [style.color]="item.customField23"
                          >close</mat-icon>
                        }
                      </div>
                      <div fxFlex="20%" class="celltype" fxLayoutAlign="center center">
                        @if (items.advanced !== 'yes' && items.advanced !== 'no') {
                          <p style="text-align: center;font-size: 11px;"
                            >
                          {{items.advanced}}</p>
                        }
                        @if (items.advanced === 'yes' ) {
                          <mat-icon class="maticon5">done</mat-icon>
                        }
                        @if (items.advanced === 'no' ) {
                          <mat-icon class="maticon6">close</mat-icon>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </mat-list>
        }
      </div>
    </div>
  </div>
}

@if (item.customField33 == '13' ) {
<div >

  @if (item.customField15 == '1' ) {
  <div fxLayout="row" class="table-align" >
      <div fxLayout="column" fxFlex="25" class="cell">
      </div>

      <div fxLayout="column" fxFlex="25" class="cell">
          <mat-icon class="maticon1">check_circle</mat-icon>
          <h4><b>Starter</b></h4>
          <button mat-stroked-button color="primary" class="trybtn1">TRY NOW</button>
      </div>

      <div fxLayout="column" fxFlex="25" class="cell">
          <mat-icon class="maticon2">check_circle</mat-icon>
          <h4><b>Professional</b></h4>
          <button mat-stroked-button color="primary" class="trybtn2">TRY NOW</button>
      </div>

      <div fxLayout="column" fxFlex="25" class="cell">
          <mat-icon class="maticon_3">check_circle</mat-icon>
          <h4><b>Advanced</b></h4>
          <button mat-stroked-button color="primary" class="trybtn3">TRY NOW</button>
      </div>
  </div>
  }

  @if (item.customField15 == '2' ) {
  <div fxLayout="row" class="table-align" [style.background-color]="item.customField20"
      [style.color]="item.customField21" >
      <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
          <h4><b>{{item.customField16}}</b></h4>
      </div>

      <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
          <h4><b>{{item.customField17}}</b></h4>
      </div>

      <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell">
          <h4><b>{{item.customField18}}</b></h4>
      </div>

      @if (item.customField19.length>0) {
      <div fxLayout="column" [fxFlex]="item.customField19==''?33.33:25" class="cell" >
          <h4><b>{{item.customField19}}</b></h4> 
      </div>
     }
      
  </div>
  }
  @for (data of pricedetail; track data) {
  <div >
    @if (data.title) {
      <div fxLayout="row" fxLayoutAlign="space-between center" class="subTitle" >
        <p><b>{{ data.title }}</b></p>
        <button  mat-icon-button (click)="toggleExpand(data)">
          <mat-icon>{{ data.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
      }
    
      @if (data.expanded) {
      <div>
        @for (item of data.list_detail; track item) {
        <div>
          <div fxLayout="row" class="rowtype">
            <div [fxFlex]="item.advanced == '' ? 33.33 : 25" class="celltype">
              <p>{{ item.sub_title }}</p>
            </div>
            <div [fxFlex]="item.advanced == '' ? 33.33 : 25" class="celltype">
              @if (item.starter !== 'yes' && item.starter !== 'no') {
              <p style="text-align: center;" >
                {{ item.starter }}
              </p>
              }
              @if (item.starter === 'yes') {
              <mat-icon class="maticon3" >check_circle</mat-icon>
              }
              @if (item.starter === 'no') {
              <mat-icon class="maticon4" >cancel</mat-icon>
              }
            </div>
            <div [fxFlex]="item.advanced == '' ? 33.33 : 25" class="celltype">
              @if (item.profession !== 'yes' && item.profession !== 'no') {
              <p style="text-align: center;" >
                {{ item.profession }}
              </p>
              }
              @if (item.profession === 'yes') {
              <mat-icon class="maticon3" >check_circle</mat-icon>
              }
              @if (item.profession === 'no') {
              <mat-icon class="maticon4" >cancel</mat-icon>
              }
            </div>
            @if (item.advanced.length > 0) {
            <div  fxFlex="25%" class="celltype">
              @if (item.advanced !== 'yes' && item.advanced !== 'no') {
              <p style="text-align: center;">
                {{ item.advanced }}
              </p>
              }
              @if (item.advanced === 'yes') {
              <mat-icon class="maticon3" >check_circle</mat-icon>
              }
              @if (item.advanced === 'no') {
              <mat-icon class="maticon4" >cancel</mat-icon>
              }
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
   }
</div>
}
